export default __webpack_public_path__ + "static/media/stadium.c4834490.jpg";